import DeviceInfo from 'react-native-device-info';

export const isSamsung = (): boolean => {
    return DeviceInfo.getBrand().toLowerCase() === 'samsung';
};

export const getBrand = (): string => {
    return DeviceInfo.getBrand();
};

export const getModel = (): string => {
    return DeviceInfo.getModel();
};

export const requiresKeyboardAvoiding = (): boolean => {
    return isSamsung();
};
